<template>
  <vs-row vs-justify="center">
    <vs-col type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="12"
            vs-xs="12"
            vs-sm="12">
      <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
      <vs-card style="border-radius: 10px;">

        <div slot="header">
          <h3 class="card-title mb-0">Configuraciones de la empresa</h3>
        </div>
        <vs-row>
          <vs-col vs-lg="12"
                  vs-xs="12"
                  vs-sm="12">
            <CompanySelector v-model="companyId" />
          </vs-col>
        </vs-row>
        <div v-if="thereCompany">
          <vs-collapse>
            <vs-collapse-item>
              <div slot="header">
                <h3 class="card-title mb-0">Comparación activa lpr</h3>
              </div>
              <vs-card style="border-radius: 10px;">
                <vs-row>
                  <vs-col vs-lg="6"
                          vs-xs="12"
                          vs-sm="12">
                    <label class="vs-input--label">{{ !isEnable ? enable : disable }} comparación</label>
                    <div class="d-flex is-align-items-stretch"> <!-- :disabled="true "-->
                      <vs-switch v-model="isEnable"
                                 vs-icon-off="close"
                                 vs-icon-on="done" />
                    </div>
                  </vs-col>
                </vs-row>
                <br>
                <vs-row>
                  <vs-col vs-lg="6"
                          vs-xs="12"
                          vs-sm="12">
                    <label class="vs-input--label">Tipo de registro</label>
                    <multiselect v-model="selectedRecords"
                                 placeholder="Seleccione tipo de registro" label="name"
                                 track-by="id"
                                 :options="showRecordTypes"
                                 :multiple="true"
                                 :taggable="true"
                                 :max-height="150"
                                 :max="50">
                    </multiselect>
                  </vs-col>
                  <vs-col vs-lg="6"
                          vs-xs="12"
                          vs-sm="12"
                          v-if="thereMonthly">
                    <label class="vs-input--label">Validación abonados</label>
                    <div class="d-flex align-items-center">
                      <div>
                        <vs-radio v-model="monthlyValidation" vs-name="monthly-validation" vs-value="itemPlate">Placa
                          registrada
                        </vs-radio>
                        <vs-radio v-model="monthlyValidation" vs-name="monthly-validation" vs-value="movementPlate">
                          Placa de
                          ingreso
                        </vs-radio>
                      </div>
                    </div>
                  </vs-col>
                </vs-row>
                <br>
                <div>
                  <h4 class="mb-0">Por carriles</h4>
                </div>
                <br>
                <vs-row>
                  <vs-col vs-lg="6"
                          vs-xs="12"
                          vs-sm="12">
                    <label class="vs-input--label">Carriles *</label>
                    <multiselect v-model="selectedLanes"
                                 placeholder="Seleccione carriles" label="title"
                                 track-by="code"
                                 :options="showLanes"
                                 :multiple="true"
                                 :taggable="true"
                                 :max-height="150"
                                 :max="50">
                    </multiselect>
                  </vs-col>
                  <vs-col vs-lg="6"
                          vs-xs="12"
                          vs-sm="12">
                    <label class="vs-input--label">Tipo de vehículo *</label>
                    <multiselect
                      v-model="selectedVehicleType"
                      placeholder="Seleccione tipo de vehículo"
                      label="name"
                      track-by="code"
                      :options="showVehiclesTypes"
                      :multiple="true"
                      :taggable="true"
                      :max-height="150"
                      :max="50">
                    </multiselect>
                  </vs-col>
                </vs-row>
                <br>
                <div>
                  <h4 class="mb-0">Sin respuesta de operario</h4>
                </div>
                <br>
                <vs-row>
                  <vs-col vs-lg="6"
                          vs-xs="12"
                          vs-sm="12">
                    <label class="vs-input--label">{{ !isNoResponse ? enable : disable }}</label>
                    <div class="d-flex is-align-items-stretch"> <!-- :disabled="true "-->
                      <div>
                        <vs-switch v-model="isNoResponse"
                                   vs-icon-off="close"
                                   vs-icon-on="done" />
                      </div>
                    </div>
                    <br>
                    <label class="vs-input--label">Tiempo máximo de espera *</label>
                    <div class="d-flex align-items-center">
                      <div>
                        <vs-input-number v-model="waitingTime"
                                         :min="1"
                                         :disabled="!isNoResponse" />
                      </div>
                      <label class="vs-input--label text-black-50"> Segundos</label>
                    </div>
                  </vs-col>
                  <vs-col vs-lg="6"
                          vs-xs="12"
                          vs-sm="12">
                    <label class="vs-input--label">Acciones</label>
                    <div class="d-flex align-items-center">
                      <div>
                        <vs-radio v-model="decision" vs-name="decision-action" vs-value="allow">Permitir
                        </vs-radio>
                        <vs-radio v-model="decision" vs-name="decision-action" vs-value="deny">Denegar
                        </vs-radio>
                      </div>
                    </div>
                  </vs-col>
                </vs-row>
                <br>
                <div>
                  <h4 class="mb-0">Excluir caracteres</h4>
                </div>
                <br>
                <vs-row>
                  <vs-col vs-lg="6"
                          vs-xs="12"
                          vs-sm="12">
                    <label class="vs-input--label">{{ !isExclude ? enable : disable }}</label>
                    <div class="d-flex is-align-items-stretch"> <!-- :disabled="true "-->
                      <div>
                        <vs-switch v-model="isExclude"
                                   vs-icon-off="close"
                                   vs-icon-on="done" />
                      </div>
                    </div>
                  </vs-col>
                  <vs-col vs-lg="6"
                          vs-xs="12"
                          vs-sm="12">
                    <label class="vs-input--label">Número de caracteres</label>
                    <div class="d-flex align-items-center">
                      <div>
                        <vs-input-number v-model="quantityCharacters"
                                         :min="1"
                                         :max="2"
                                         :disabled="!isExclude" />
                      </div>
                      <label class="vs-input--label text-black-50">(Máximo 2 caracteres)</label>
                    </div>
                  </vs-col>
                </vs-row>
                <hr class="custom-hr" />
                <div class="d-inline-block d-md-flex align-items-center">
                  <div class="btn-alignment">
                    <vs-button @click="saveComparisonSetting()">Guardar cambios</vs-button>
                  </div>
                </div>
              </vs-card>
            </vs-collapse-item>
            <vs-collapse-item>
              <div slot="header">
                <h3 class="card-title mb-0">Descuentos</h3>
              </div>
              <vs-card style="border-radius: 10px;">
                <vs-row>
                  <vs-col vs-lg="6"
                          vs-xs="12"
                          vs-sm="12">
                    <label class="vs-input--label">
                      Habilitar acumulación de descuentos
                    </label>
                    <div class="d-flex is-align-items-stretch"> <!-- :disabled="true "-->
                      <div>
                        <vs-switch v-model="isCumulativeDiscounts"
                                   vs-icon-off="close"
                                   vs-icon-on="done"
                                   style="width: 5em;height: 2em;" />
                      </div>
                    </div>
                  </vs-col>
                  <vs-col vs-lg="6"
                          vs-xs="12"
                          vs-sm="12">
                    <div class="btn-alignment">
                      <vs-button @click="saveCumulativeDiscounts()">Guardar cambios</vs-button>
                    </div>
                  </vs-col>
                </vs-row>
              </vs-card>
            </vs-collapse-item>
          </vs-collapse>
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</template>
<script>

import CompanySelector from '@/components/Shared/CompanySelector/index.vue'
import multiselect from 'vue-multiselect'
import VehicleEndPoint from '@/endpoints/core/VehicleEndPoint'
import toast from '@/global/ToastConfig'
import deviceEndpoint from '@/endpoints/machine/DeviceEndpoint'
import { companySettingTypes } from '@/global/constants'
import CompanySettingEndpoints from '@/endpoints/core/CompanySettingEndpoints'

export default {
  components: { multiselect, CompanySelector },
  data() {
    return {
      companyId: null,
      thereCompany: false,
      isLoading: false,
      isEnable: null,
      isExclude: false,
      isNoResponse: false,
      thereMonthly: false,
      selectedRecords: [],
      showRecordTypes: [
        { id: 'subscriber', name: 'Abonados' },
        { id: 'rotation', name: 'Rotación' }
      ],
      monthlyValidation: 'movementPlate',
      showLanes: [],
      selectedLanes: [],
      showVehiclesTypes: [],
      selectedVehicleType: [
        { name: 'Carro', code: 11 },
        { name: 'Moto', code: 12 }],
      waitingTime: 1,
      decision: 'allow',
      quantityCharacters: 1,
      enable: 'Habilitar',
      disable: 'Deshabilitar',
      setting: null,
      codeComparison: null,
      isCumulativeDiscounts: false,
      settingCumulative: null,
      codeCumulative: null

    }
  },
  watch: {
    companyId() {
      this.companyValidate()
    },
    selectedRecords() {
      this.recordMonthlyValidate()
    }
  },
  mounted() {
    this.companyValidate()
  },
  methods: {
    companyValidate() {
      this.isLoading = true
      if (!this.companyId) {
        this.isLoading = false
        this.thereCompany = false
        return
      }
      this.getLanes()
      this.getVehicleTypes()
      this.findComparisonCompany()
      this.findCumulativeDiscountsCompany()
      this.thereCompany = true
    },
    /**
     * Valida si existe configuracion de comparacion Activa en la compañia
     */
    findComparisonCompany() {
      try {
        this.cleanComparisonForm()
        const params = {
          companyId: this.companyId
        }
        CompanySettingEndpoints.findComparisonSettingByCompany(params)
          .then(data => {
            if (data.code === 0) {
              toast.info('No se encontro configuración de comparación activa de esta compañía')
              return
            }
            if (data.code < 0) {
              return
            }
            const info = data.info
            this.setFormComparisonSetting(info)
          })
      } catch (error) {
        toast.error(error.message)
      }
    },
    findCumulativeDiscountsCompany() {
      try {
        this.cleanCumulativeForm()
        const params = {
          companyId: this.companyId
        }
        CompanySettingEndpoints.findCumulativeDiscountByCompany(params)
          .then(data => {
            if (data.code === 0) {
              toast.info('No se encontro configuración de acumulación de descuentos')
              this.isLoading = false
              return
            }
            if (data.code < 0) {
              this.isLoading = false
              return
            }
            const infoSetting = JSON.parse(data.info.info)
            this.codeCumulative = data.info.code
            this.isCumulativeDiscounts = infoSetting.cumulativeDiscount.value
            this.isLoading = false
          })
      } catch (error) {
        toast.error(error.message)
      }
    },
    cleanComparisonForm() {
      this.codeComparison = null
      this.isEnable = false
      this.selectedRecords = []
      this.monthlyValidation = 'movementPlate'
      this.selectedVehicleType = [
        { name: 'Carro', code: 11 },
        { name: 'Moto', code: 12 }
      ]
      this.waitingTime = 1
      this.decision = 'allow'
      this.isExclude = false
      this.quantityCharacters = 1
      this.selectedLanes = []
    },
    cleanCumulativeForm() {
      this.codeCumulative = null
      this.isCumulativeDiscounts = false
    },
    /**
     * obtien los tipos de vehiculo
     */
    getVehicleTypes() {
      try {
        this.showVehiclesTypes = []
        VehicleEndPoint.getListGeneral()
          .then(data => {
            if (data.code === 0) {
              return
            }
            if (data.code < 0) {
              return
            }
            data.info.forEach((vehicle) => {
              const unity = {
                name: vehicle.title,
                code: vehicle.code
              }
              this.showVehiclesTypes.push(unity)
            })
          })
      } catch (error) {
        toast.error(error.message)
      }
    },
    /**
     * obtienne los carriles de un parqueadero
     */
    getLanes() {
      try {
        this.showLanes = []
        const params = {
          companyId: this.companyId
        }
        deviceEndpoint.listLanesByCompany(params)
          .then(lanes => {
            lanes.forEach(laneDevice => {
              const lane = {
                code: laneDevice.code,
                title: laneDevice.title
              }
              this.showLanes.push(lane)
            })
          })
      } catch (error) {
        toast.error(error.message)
      }
    },
    /**
     * envia los datos guardados de la configuracion al formulario
     */
    setFormComparisonSetting(objInfo) {
      const settingInfo = JSON.parse(objInfo.info)
      this.codeComparison = objInfo.code
      this.isEnable = objInfo.status === 'ACTIVE'
      this.selectedRecords = this.autoFillSelectedRecords
      (settingInfo.monthlyRecord.status, settingInfo.rotationRecord.status)
      this.monthlyValidation = settingInfo.monthlyRecord.validatePlate
      this.selectedVehicleType = settingInfo.vehicleTypes
      this.selectedLanes = settingInfo.lanes
      this.isExclude = settingInfo.characterExclude > 0
      this.quantityCharacters = settingInfo.characterExclude > 0 ? settingInfo.characterExclude : 1
      this.isNoResponse = settingInfo.noOperatorResponse.status === 'ACTIVE'
      this.waitingTime = settingInfo.noOperatorResponse.waitingTime
      this.decision = settingInfo.noOperatorResponse.action

    },
    /**
     * VALIDA LOS DATOS DE TIPO DE REGISTRO EN EL SISTEMA
     * @param monthlyStatus
     * @param rotationStatus
     * @returns {*[]}
     */
    autoFillSelectedRecords(monthlyStatus, rotationStatus) {
      const listRecords = []
      if (monthlyStatus === 'ACTIVE') {
        listRecords.push(this.showRecordTypes[0])
      }
      if (rotationStatus === 'ACTIVE') {
        listRecords.push(this.showRecordTypes[1])
      }
      return listRecords
    },
    /**
     * guarda la configuracion de comparacion activa de la compañia
     */
    saveComparisonSetting() {
      try {
        this.validateFormSetting()
        this.isLoading = true
        const objSetting = this.prepareSetting()
        CompanySettingEndpoints.saveCompanySetting(objSetting)
          .then(code => {
            if (code > 0) {
              this.findComparisonCompany()
              this.isLoading = false
            }
          })
          .finally(() => this.isLoading = false)
      } catch (error) {
        toast.error(error.message)
      }
    },
    /**
     * valida los datos del formulario a guardar
     */
    validateFormSetting() {
      if (!this.companyId) {
        throw new Error('Seleccione una compañia')
      }
      if (this.selectedRecords.length === 0) {
        throw new Error('Debe seleccionar almenos un tipo de registro')
      }
      if (this.showLanes.length === 0) {
        throw new Error('La compañía no tiene carriles configurados')
      }
    },
    /**
     * * Prepara el CompanySetting a guardar
     * @returns {{code: null, company: {code: null}, title: string, info: string}}
     */
    prepareSetting() {
      return {
        code: this.codeComparison,
        status: this.isEnable ? 'ACTIVE' : 'INACTIVE',
        company: { code: this.companyId },
        title: companySettingTypes.PLATE_COMPARISON.title,
        info: JSON.stringify(this.prepareInfoSetting())
      }
    },
    /**
     * metodo que valida si seleccionaron un tipo de vehiculo o si no que tenga encuenta todos los tipos
     * @returns {Promise<*>}
     */
    getValidateVehicles() {
      return this.selectedVehicleType.length === 0
        ? this.showVehiclesTypes
        : this.selectedVehicleType
    },
    /**
     * metodo que valida si seleccionaron carilles o si no que tenga encuenta todos los carriles
     * @returns {*}
     */
    getValidateLanes() {
      return this.selectedLanes.length === 0
        ? this.showLanes
        : this.selectedLanes
    },
    /**
     * Prepara el JSON para enviar en el info del  CompanySetting a guardar
     * @returns {{rotationRecord: {status: (string)}, noOperatorResponse: {waitingTime: number, action: string}, characterExclude: (number), vehicleTypes: Promise<*>, monthlyRecord: {validatePlate: string, status: (string)}}}
     */
    prepareInfoSetting() {
      return {
        monthlyRecord: {
          status: this.thereMonthly ? 'ACTIVE' : 'DISABLE',
          validatePlate: this.monthlyValidation
        },
        rotationRecord: { status: this.recordRotationValidate() ? 'ACTIVE' : 'DISABLE' },
        vehicleTypes: this.getValidateVehicles(),
        lanes: this.getValidateLanes(),
        noOperatorResponse: {
          status: this.isNoResponse ? 'ACTIVE' : 'DISABLE',
          waitingTime: this.isNoResponse ? parseInt(this.waitingTime) : 0,
          action: this.decision
        },
        characterExclude: parseInt(!this.isExclude ? 0 : this.quantityCharacters)
      }
    },
    /**
     * valida si seleccionaron Abonados en tipo de registro
     */
    recordMonthlyValidate() {
      this.thereMonthly = false
      if (this.selectedRecords.length === 0) {
        return
      }
      this.selectedRecords.forEach(selected => {
        if (selected.id === 'subscriber') {
          this.thereMonthly = true
        }
      })
    },
    /**
     *  valida si seleccionaron rotacion en tipo de registro
     * @returns {boolean}
     */
    recordRotationValidate() {
      for (let i = 0; i < this.selectedRecords.length; i++) {
        if (this.selectedRecords[i].id === 'rotation') {
          return true
        }
      }
      return false
    },
    saveCumulativeDiscounts() {
      try {
        if (!this.companyId) {
          throw new Error('Seleccione una compañia')
        }
        this.isLoading = true
        const cumulativeSetting = this.getCumulativeDiscountSetting()
        CompanySettingEndpoints.saveCompanySetting(cumulativeSetting)
          .then((code) => {
            if (code > 0) {
              this.findCumulativeDiscountsCompany()
              this.isLoading = false
            }
          }).finally(() => this.isLoading = false)
        this.findCumulativeDiscountsCompany()
      } catch (error) {
        toast.error(error.message)
      }
    },

    getCumulativeDiscountSetting() {
      return {
        code: this.codeCumulative,
        company: {
          code: this.companyId
        },
        title: companySettingTypes.CUMULATIVE_DISCOUNTS.title,
        status: 'ACTIVE',
        info: JSON.stringify(this.prepareCumulativeInfo())
      }
    },
    prepareCumulativeInfo() {
      return {
        cumulativeDiscount: {
          value: this.isCumulativeDiscounts

        }
      }
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css" />
<style>
.v-input--switch__track {
  border-radius: 15px;
  width: 48px;
  height: 29px;
  top: -2px;
}

.v-input--switch__thumb {
  left: 6px;
}

.custom-switch .v-input__slot .v-label {
  left: 6px !important
}

.v-input--selection-controls__ripple {
  height: 0;
  width: 0
}
</style>
